








































import { Component, Mixins, Prop } from "vue-property-decorator";
import RequestedDocumentProcessor from "./helpers/RequestedDocumentProcessor.vue";
import { FixedLoading } from "../system";
import { NewQuotedDocumentEditor } from "./editors";
import {
  EmbeddedDocumentEditViewMixin,
} from "./mixins";

@Component({
  components: {
    FixedLoading,
    NewQuotedDocumentEditor,
    RequestedDocumentProcessor,
  },
})
export default class EmbeddedNewQuotedDocumentEditView extends Mixins(EmbeddedDocumentEditViewMixin) {
  @Prop()
  defaultFormatId: number;

  @Prop()
  folderId: string;

  @Prop()
  defaultFormatTabName: string;

  @Prop()
  documentKindIds: number[];

  @Prop()
  formatId: number;

  @Prop()
  chainedFormatIds: number[];

  @Prop()
  quotedDocumentId: number;

  @Prop()
  institutionNo: string;
  
  @Prop()
  regionalInstitutionNo: string;

  @Prop()
  hisInfoGetterParameter: string;

  @Prop()
  systemKey: string;

  @Prop()
  linkKey: string;

  @Prop()
  orderNo: string;

  @Prop()
  postRegistrationProcess: (id: number) => Promise<void>;

  $refs!: {
    processor: RequestedDocumentProcessor;
    quotedEditor: NewQuotedDocumentEditor;
  };

  mounted() {
    this.embeddedComponent = this.$refs.quotedEditor;
  }

  async validateSelectedFormat(format: any): Promise<boolean> {
    return this.validateFormat(format, false);
  }

  validateSelectedFormatWriteMethod(format: any): boolean {
    return this.validateFormatWriteMethod(format, false);
  }
}
